/* globals Class, $H, lp, jui */
var _ = require('lodash');

var rxUi = window.rxUi;

;(function(){
  lp.editor.TransformBoxHandle = Class.create(jui.Component, {
    _handleNames: ['tlh','trh','blh','brh','tmh','rmh','bmh','lmh'],
    options: function($super, options){
      return $super($H({
        attributes:{className:'transform-handle'},
        snap:true}).merge(options));
    },

    initialize: function($super, box, handleName, routingKey){
      this._routingKey = routingKey || 'TransformBoxHandle';
      if (!_.contains(this._handleNames, handleName)) {
        throw new Error('invalid transform handle name: ' + handleName);
      }
      this.name = handleName;
      this.box = box;
      // mutable state that changes for each drag. We need a brand new
      // instance of the helper for each drag
      this.dragCallback = null;
      $super({classNames: [handleName, 'transform-handle-' + handleName]});
    },

    installUI: function($super, options) {
      $super(options);

      var self = this;
      this._uiBinding = new rxUi.Binding([this._routingKey, this.name]);
      this._uiBinding.bindDrag(this.e)
        .ub_subscribe(function (ev) {
          if (ev.type === 'startDrag') {
            self.box.tracking = true;
            self.dragCallback = self._getDragHandlerCallback();
          } else if (ev.type === 'endDrag') {
            self.box.undoRegistered = false;
            self.box.tracking = false;
          } else if (ev.type === 'drag') {
            self.dragCallback(ev);
          }
        });
    },

    _getDragHandlerCallback: function () {
      var elm = this.box.elm;
      var helperClass;
      if (elm.type === 'lp-pom-text') {
        helperClass = lp.editor.TextTransformBoxHandleHelper;
      } else if (elm.type === 'lp-pom-block') {
        helperClass = lp.editor.SectionTransformBoxHandleHelper;
      } else {
        helperClass = lp.editor.TransformBoxHandleHelper;
      }
      var helper = new helperClass(this.box, elm);
      var dragCallback = helper[this._getHelperMethodName()];
      if (!dragCallback) {
        throw new Error(
          'Could not find transform handle callback for ' + this.box.elm.id + ' ' + this.name);
      }
      return dragCallback;
    },

    _getHelperMethodName: function() {
      return {
        'tlh': 'handleDragTopLeft',
        'trh': 'handleDragTopRight',
        'blh': 'handleDragBottomLeft',
        'brh': 'handleDragBottomRight',
        'lmh': 'handleDragLeft',
        'tmh': 'handleDragTop',
        'rmh': 'handleDragRight',
        'bmh': 'handleDragBottom'
      }[this.name];
    }
  });
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/transform_box_handle.js
// module id = 1027
// module chunks = 0